import { useEffect} from "react";
import { useAuthStore } from "../contexts/AuthContext";
import { useAccountDataTableDispatch } from "../contexts/AccountDataTableContext";

export default function useGetAccountDataTables() {
  const accountdatatableDispatch = useAccountDataTableDispatch();
  const { selectedAccount } = useAuthStore();
  
  //make the accountdatatables rerender
  useEffect(() => {
    accountdatatableDispatch({
      type: "setIsLoadingAccountDataTables",
      payload: true,
    });
    
    let url = selectedAccount.id
      ? `/api/account-datatables?account=${selectedAccount.id}`
      : "/api/account-datatables";
    fetch(url, {credentials: 'include'})
      .then((response) => response.json())
      .then((r) => {
        accountdatatableDispatch({
          type: "setAccountDataTables",
          payload: r,
        });
        if(r.msg === "ok") {
          const accountDataTableDictionary = r.DataTables.reduce((acc, dt) => {
            acc[dt?.DataTable?.slug] = true;
            return acc;
          }, {});
          accountdatatableDispatch({
            type: "setAvailableAccountDataTables",
            payload: accountDataTableDictionary,
          });
        }

        accountdatatableDispatch({
          type: "setIsLoadingAccountDataTables",
          payload: false,
        });
      });
  }, [selectedAccount, accountdatatableDispatch]);
}


// PAYLOAD=> {accountInfo: selectedAccount, dataTable: dataTable} dataTable is taking from the dashboardDataTable store and mapped/passed into each upload component
export function useCreateAccountDataTable() {
  const createAccountDataTable = async (payload) => {
    try {
      const response = await fetch(`/api/account-datatables`, {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      });
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(`Error in createAccountDataTable: ${errorData}`)
      }
      const data = await response.json();
      const statusCode = response.status;

      // Return whether it was created (no preAgg refresh needed) or updated (refresh needed)
      if (statusCode === 201) {
        return { newAccountDataTable: data, refreshPreAggregate: false };
      } else if (statusCode === 200) {
        return { newAccountDataTable: data, refreshPreAggregate: true };
      }
      return data
    } catch (err) {
      console.error('Fetch error:', err);
      return null
    }
  }
  return { createAccountDataTable};
}
